import React from "react";
import {
  DialogActions,
  InnerDialogActions,
  SubmitButton,
  ResultRow,
  ResultText,
} from "./styles";
import { CircularProgress } from "../../../../../CircularProgress";
import { ButtonColor } from "../../../../../Button/styles";
import { CtaButton } from "../../../../components/CtaButton";

type Props = {
  isLoading: boolean;
  isReview: boolean;
  buttonText: string;
  color: ButtonColor;
  isButtonDisabled: boolean;
  resultText?: string;
  backgroundColor: "primary" | "positive" | "negative" | "warning" | undefined;
  onSubmit: VoidFunction;
};

export function Ungraded({
  isLoading,
  isReview,
  buttonText,
  color,
  isButtonDisabled,
  resultText,
  backgroundColor,
  onSubmit,
}: Props) {
  return (
    <DialogActions
      color={isReview ? undefined : backgroundColor}
      $isSubmitted={false}
    >
      {resultText && !isReview && (
        <ResultRow>
          <ResultText>{resultText}</ResultText>
        </ResultRow>
      )}
      <InnerDialogActions>
        {isReview ? (
          <CtaButton text="Next" onClick={onSubmit} />
        ) : (
          <SubmitButton
            color={color}
            align="center"
            type="button"
            disabled={isLoading || isButtonDisabled}
            startIcon={
              isLoading ? (
                <CircularProgress size="xs" color={"black"} />
              ) : undefined
            }
            text={isLoading ? "" : buttonText}
            onClick={onSubmit}
          />
        )}
      </InnerDialogActions>
    </DialogActions>
  );
}
